import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import axios from "axios";
import { ApiStatics } from "../../Config/Static";

export const getAllEvents = createAsyncThunk(
  `events/getEvents`,
  async (navigate, { getState }) => {
    const state = getState();
    const eventState = state.event;

    try {
      let data = await axios.get(
        eventState.filter.location != null && eventState.filter.location !== ""
          ? `${process.env.REACT_APP_API_BACKEND_URL}/${ApiStatics.events.event}/${ApiStatics.dashboard.dashboard}?location=${eventState.filter.location}`
          : `${process.env.REACT_APP_API_BACKEND_URL}/${ApiStatics.events.event}/${ApiStatics.dashboard.dashboard}`
      );
      console.log(" data.data.data.data", data.data.data.data);
      return {
        success: true,
        data: data.data.data.data,
      };
    } catch (error) {
      return {
        success: false,
        error: error.message,
      };
    }
  }
);

export const getAllEventCategories = createAsyncThunk(
  `events/getAllEventCategories`,
  async () => {
    try {
      let data = await axios.get(
        `${process.env.REACT_APP_API_BACKEND_URL}/${ApiStatics.events.event}/${ApiStatics.web.web}/${ApiStatics.web.categories}`
      );
      return {
        success: true,
        data: data.data.data.data,
      };
    } catch (error) {
      return {
        success: false,
        error: error.message,
      };
    }
  }
);

export const getAllFilterEvents = createAsyncThunk(
  `events/getAllFilterEvents`,
  async (arg, { getState }) => {
    const state = getState();
    const eventState = state.event;

    try {
      let data = await axios.post(
        `${process.env.REACT_APP_API_BACKEND_URL}/${ApiStatics.events.event}/${ApiStatics.dashboard.dashboard}/${ApiStatics.events.filter}`,
        {
          filter: eventState.filter,
          query: eventState.searchQuery,
        }
      );
      return {
        success: true,
        data: data.data.data.data,
      };
    } catch (error) {
      return {
        success: false,
        error: error.message,
      };
    }
  }
);

export const getEventById = createAsyncThunk(
  `events/getEventById`,
  async ({ id, navigate }) => {
    const token = localStorage.getItem("token");
    const config = {
      headers: {
        Authorization: "Bearer " + token,
      },
    };
    try {
      let data = await axios.get(
        `${process.env.REACT_APP_API_BACKEND_URL}/${ApiStatics.events.event}/${id}`,
        config
      );
      console.log("events", data.data.data);
      return {
        success: true,
        data: data.data.data.data,
      };
    } catch (error) {
      return {
        success: false,
        error: error.message,
      };
    }
  }
);

const initialState = {
  dashboardData: [],
  eventsToRender: [],
  filteredEvents: [],
  eventFilter: "all",
  filter: {
    startPrice: null,
    endPrice: null,
    category: null,
    date: null,
    location: null,
  },
  categories: [],
  filterList: {},
  searchQuery: "",
  applications: [],
  applicants: null,
  loading: false,
  updateLoading: false,
  eventDetails: {
    title: "",
    type: "",
    bookingPrice: 0,
    description: "",
    host: "",
    imageSrc: "",
    startDate: "",
    startTime: "",
    endDate: "",
    endTime: "",
    entryType: "",
    questions: [],
    tickets: [
      {
        title: "",
        price: "",
      },
    ],
    location: {
      type: "venue",
      addressLine1: "",
      addressLine2: "",
      city: "",
      state: "",
      meetingLink: "",
    },
  },
  error: {
    result: false,
    message: "",
  },
};

const EventSlice = createSlice({
  name: "events",
  initialState,
  reducers: {
    resetEventDetails(state, { payload }) {
      state.eventDetails = {
        eventTitle: "",
        eventType: "",
        description: "",
        host: "",
        imageSrc: "",
        startDate: "",
        startTime: "",
        endDate: "",
        endTime: "",
        entryType: "",
        questions: [],
        tickets: [
          {
            title: "",
            price: "",
          },
        ],
        location: {
          type: "",
          addressLine1: "",
          addressLine2: "",
          city: "",
          state: "",
          meetingLink: "",
        },
      };
    },

    addEventTicketDetails(state, { payload }) {
      state.eventDetails = {
        ...state.eventDetails,
        entryType: payload.entryType,
        tickets: payload.tickets,
      };
      // state.eventDetails.entryType = payload.entryType;
      // state.eventDetails.;
    },
    updateSearchQuery(state, { payload }) {
      state.searchQuery = payload;
    },
    addFilterList(state, { payload }) {
      const { type, value } = payload;
      state.filterList[type] = value;
    },
    clearFilter(state, { payload }) {
      state.filterList[payload] = null;
      switch (payload) {
        case "Category":
          state.filter.category = null;
          break;
        case "Date":
          state.filter.date = null;
          break;
        case "Price":
          state.filter.startPrice = null;
          state.filter.endPrice = null;
          break;
        default:
          state.filter = {
            startPrice: null,
            endPrice: null,
            category: null,
            date: null,
          };
      }
    },
    addFilter(state, { payload }) {
      state.filter = {
        startPrice:
          payload.startPrice === ""
            ? state.filter.startPrice
            : payload.startPrice,
        endPrice:
          payload.endPrice === "" ? state.filter.endPrice : payload.endPrice,
        category:
          payload.category === ""
            ? state.filter.category
            : payload.category?.toLowerCase(),
        date: payload.date === "" ? state.filter.date : payload.date,
        location:
          payload.location === "" ? state.filter.location : payload.location,
      };
      // state.eventDetails.entryType = payload.entryType;
      // state.eventDetails.;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllEvents.pending, (state, action) => {
        state.loading = true;
        state.error = initialState.error;
      })
      .addCase(getAllEvents.fulfilled, (state, action) => {
        state.loading = false;
        state.dashboardData = action.payload.data;
        state.eventsToRender = action.payload.data;
        state.success = true;
      });
    builder.addCase(getAllEventCategories.fulfilled, (state, action) => {
      state.categories = action.payload.data;
    });
    builder
      .addCase(getAllFilterEvents.pending, (state, action) => {
        state.loading = true;
        state.error = initialState.error;
        state.filteredEvents = [];
      })
      .addCase(getAllFilterEvents.fulfilled, (state, action) => {
        state.loading = false;
        state.filteredEvents = action.payload.data;
        state.success = true;
      })

      .addCase(getEventById.pending, (state, action) => {
        state.loading = true;
        state.eventDetails = null;
        state.error = initialState.error;
      })
      .addCase(getEventById.fulfilled, (state, action) => {
        if (!action.payload.success) {
          state.loading = false;
          state.error.result = true;
          state.error.message = action.payload.error;
          return;
        }
        state.eventDetails = {
          ...action.payload.data,
        };
        state.loading = false;
        state.success = true;
      });
  },
});

export const {
  updateEventDetails,
  addEventTicketDetails,
  addFilter,
  resetEventDetails,
  addFilterList,
  clearFilter,
  updateSearchQuery,
} = EventSlice.actions;
export default EventSlice.reducer;
